import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";
import { useTestingStore } from "@/stores/testingStore";

/**
 * Thin selector over `testingStore`'s execution-run slice. The SSE stream lives in the store (module
 * scope), so it survives tab navigation — the run's live steps keep flowing on return. (A hard reload
 * still wipes it, but the run is a server-side job recovered by the runs poll.)
 */
export function useExecutePlan() {
	const queryClient = useQueryClient();
	const events = useTestingStore((s) => s.execEvents);
	const result = useTestingStore((s) => s.execResult);
	const isStreaming = useTestingStore((s) => s.execStreaming);
	const error = useTestingStore((s) => s.execError);
	const executeAction = useTestingStore((s) => s.execute);
	const abort = useTestingStore((s) => s.execAbort);
	const reset = useTestingStore((s) => s.execReset);

	const execute = useCallback(
		(planId: string, opts?: { headed?: boolean; live?: boolean }) =>
			executeAction(planId, opts, queryClient),
		[executeAction, queryClient],
	);

	return { execute, abort, reset, events, result, isStreaming, error };
}
